import * as React from "react";
import { Link } from "gatsby";
import LoadingState from "../../../../ui-library/loading-state/loading-state";
import { Colors } from "../../../../design-tokens/colors";
import { GrowthFactorByCountries_covidCaseOwidByCountries_data } from "../../../../../apollo-types/GrowthFactorByCountries";
import styles from "./country-infection-rate.styles";
import InfectionRateChart from "./infection-rate-chart";

interface CountryInfectionRateProps {
  countryName: string;
  countryUrl?: string;
  benchmarkCountryName?: string;
  data?: GrowthFactorByCountries_covidCaseOwidByCountries_data[] | null;
  benchmarkData?:
    | GrowthFactorByCountries_covidCaseOwidByCountries_data[]
    | null;
  loading?: boolean;
}

const formatData = (
  data: GrowthFactorByCountries_covidCaseOwidByCountries_data[]
) => {
  const formatGrowthFactor = data.map((d) => {
    return {
      date: d.date,
      value: d.infectionRate || 1,
    };
  });

  return formatGrowthFactor.length > 30
    ? formatGrowthFactor.slice(
        formatGrowthFactor.length - 30,
        formatGrowthFactor.length
      )
    : formatGrowthFactor;
};

const CountryInfectionRate: React.FC<CountryInfectionRateProps> = ({
  countryName,
  countryUrl,
  benchmarkCountryName,
  data,
  benchmarkData,
  loading,
}) => {
  if (loading) {
    return (
      <div>
        <div css={styles.headingContainer}>
          <div css={styles.heading}>{countryName}</div>
        </div>
        <LoadingState height={150} />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const dataToDisplay = formatData(data);
  const benchmarkDataToDisplay = benchmarkData && formatData(benchmarkData);

  if (!dataToDisplay || !dataToDisplay[dataToDisplay.length - 1]) {
    return null;
  }

  const value = dataToDisplay[dataToDisplay.length - 1].value || "-";

  return (
    <div>
      <div css={styles.headingContainer}>
        {countryUrl ? (
          <Link css={styles.heading} to={countryUrl}>
            {countryName}
          </Link>
        ) : (
          <div css={styles.heading}>{countryName}</div>
        )}
        <div css={styles.infoContainer}>
          <div css={styles.description}>Current daily infection rate</div>
          <div
            css={[
              styles.value,
              { color: value > 1 ? Colors.Pink : Colors.Green },
            ]}
          >
            {value}
          </div>
        </div>
      </div>
      <InfectionRateChart
        data={dataToDisplay}
        benchmarkData={benchmarkDataToDisplay}
        country={countryName}
        benchmarkCountryName={benchmarkCountryName}
      />
    </div>
  );
};

export default CountryInfectionRate;
